import React from 'react';
import './FilterTasks.css';
import { filter } from './filter';

var filtered = false;
var category = "";
var dateStart = "";
var timeStart = "";
var dateEnd = "";
var timeEnd = "";

export function hasFilter() {
    return filtered;
}

function closePopup() {
    document.getElementById("opacity-layer3").style.display = "none";
    document.getElementById("filter-categories-popup").style.display = "none";
    if(!filtered) {
        document.getElementById("filter-categories-category").value = "";
        document.getElementById("filter-categories-date-start").value = "";
        document.getElementById("filter-categories-time-start").value = "";
        document.getElementById("filter-categories-date-end").value = "";
        document.getElementById("filter-categories-time-end").value = "";
    }
}

function filterTasks(e) {
    e.preventDefault();
    if(document.getElementById("filter-categories-category").value == "" && document.getElementById("filter-categories-date-start").value == "" && document.getElementById("filter-categories-time-start").value == "" && document.getElementById("filter-categories-date-end").value == "" && document.getElementById("filter-categories-time-end").value == "") {
        alert("Please enter a filter");
        return;
    }
    category = document.getElementById("filter-categories-category").value;
    dateStart = document.getElementById("filter-categories-date-start").value;
    timeStart = document.getElementById("filter-categories-time-start").value;
    dateEnd = document.getElementById("filter-categories-date-end").value;
    timeEnd = document.getElementById("filter-categories-time-end").value;
    filtered = true;
    filter();
    closePopup();
}

export function getFilter() {
    return {
        category: category,
        dateStart: dateStart,
        timeStart: timeStart,
        dateEnd: dateEnd,
        timeEnd: timeEnd
    };
}

export function clearFilter() {
    filtered = false;
    document.getElementById("filter-categories-category").value = "";
    document.getElementById("filter-categories-date-start").value = "";
    document.getElementById("filter-categories-time-start").value = "";
    document.getElementById("filter-categories-date-end").value = "";
    document.getElementById("filter-categories-time-end").value = "";
    category = "";
    dateStart = "";
    timeStart = "";
    dateEnd = "";
    timeEnd = "";
    closePopup();
    filter();
}

class FilterTasks extends React.Component {

    render() {
        return (
            <div>
                <div id="opacity-layer3" onClick={closePopup} ></div>
                <div id="filter-categories-popup">
                    <h3 className='form-title'>Filter Tasks</h3>
                    <form id="filter-categories-form">
                        <div className="form-group">
                            <label htmlFor="filter-categories-category">Category</label>
                            <select className="form-control" id="filter-categories-category">
                                <option value="">Select:</option>
                                <option value="None">None</option>
                                <option value="Personal">Personal</option>
                                <option value="School">School</option>
                                <option value="Work">Work</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="filter-categories-date">Start</label>
                            <input type="date" className="form-control" id="filter-categories-date-start" />
                            <input type="time" className="form-control" id="filter-categories-time-start" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="filter-categories-time">End</label>
                            <input type="date" className="form-control" id="filter-categories-date-end" />
                            <input type="time" className="form-control" id="filter-categories-time-end" />
                        </div>
                        <div className="form-group">
                            <button type="submit" className="btn btn-primary" id="filter-categories-submit" onClick={filterTasks} >📑 Filter</button>
                            <button type="button" className="btn btn-primary" id="filter-categories-clear" onClick={() => clearFilter()} >🚫 Clear</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
export default FilterTasks;